module.exports = __webpack_public_path__ + "static/media/SunainaPuri.c08fd976.png";